import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { disableNoveltyBadge, ALLOWED_BADGE_PATHS } from './useNoveltyBadge'

export function useNoveltyBadgeRouteWatcher (): void {
  const route = useRoute()

  watch(
    () => route.path,
    (newPath) => {
      for (const allowedPath of ALLOWED_BADGE_PATHS) {
        if (newPath.includes(allowedPath)) {
          disableNoveltyBadge(allowedPath)
        }
      }
    },
    { immediate: true }
  )
}
